import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

export const IconGraduateCap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGraduateCap"><G ClipPath="url(#clip0_9850_24745)"><Path d="M12.0004 2.87744L0 9.00008L12.0004 15.1227L19.5004 11.2962L22.0004 10.0207V17.0001H24.0004V9.00026L12.0004 2.87744Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M4.50037 12.8009V17.3L12.0003 21.1181L19.5004 17.3V12.8009L12.0004 16.62L4.50037 12.8009Z" fill="currentColor"/></G><Defs><ClipPath id="clip0_9850_24745"><Rect width="24" height="24" fill="white"/></ClipPath></Defs></CentralIconBase>;
});

export default IconGraduateCap;
